import React, { useEffect } from 'react';
import { IconSend } from '../common/Icons';
import { useI18n } from '../../services/i18n';
import { money } from '../../services/api';

export default function Referral({
  referralData,
  loadReferralData,
  onShowToast
}) {
  const { t } = useI18n();

  useEffect(() => {
    loadReferralData();
  }, [loadReferralData]);

  const r = referralData;
  const pct = r?.percent != null ? `${r.percent}%` : '10%';
  const cleanLink = r?.link ? r.link.replace(/^https?:\/\//, '') : '…';

  const handleCopy = () => {
    if (r?.link) {
      if (navigator.clipboard?.writeText) {
        navigator.clipboard.writeText(r.link);
      }
      onShowToast(t('toast_link_copied'));
      window.Telegram?.WebApp?.HapticFeedback?.notificationOccurred?.('success');
    }
  };

  const handleShare = () => {
    if (!r?.link) return;
    const url = `https://t.me/share/url?url=${encodeURIComponent(r.link)}&text=${encodeURIComponent(t('share_text'))}`;
    if (window.Telegram?.WebApp?.openTelegramLink) {
      window.Telegram.WebApp.openTelegramLink(url);
    } else {
      window.open(url, '_blank');
    }
  };

  return (
    <main
      className="screen"
      style={{ paddingBottom: 'calc(var(--tabbar-h) + 24px)' }}
      data-testid="screen-referral"
    >
      <div className="col" style={{ gap: '6px' }}>
        <h1>{t('ref_title')}</h1>
        <p className="muted" style={{ margin: 0, fontSize: '15px', lineHeight: 1.5 }}>
          {t('ref_desc', { pct })}
        </p>
      </div>

      <div className="grid2" style={{ gap: '10px' }}>
        <div className="card" style={{ gap: '4px' }}>
          <span className="small muted" style={{ fontWeight: 600 }}>{t('ref_invited')}</span>
          <span className="stat" data-testid="ref-invited">
            {r ? r.invited : '…'}
          </span>
        </div>
        <div className="card" style={{ gap: '4px' }}>
          <span className="small muted" style={{ fontWeight: 600 }}>{t('ref_earned')}</span>
          <span className="stat" data-testid="ref-earned">
            {r ? money(r.earned) : '…'}
          </span>
        </div>
      </div>

      <section className="col">
        <span className="label">{t('ref_link_label')}</span>
        <div className="field" style={{ padding: '6px 6px 6px 14px', height: 'auto' }}>
          <span
            style={{
              flex: 1,
              minWidth: 0,
              fontSize: '14px',
              fontWeight: 600,
              color: 'var(--text-2)',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap'
            }}
            data-testid="ref-link-text"
          >
            {cleanLink}
          </span>
          <button
            className="pill"
            style={{
              height: '40px',
              borderRadius: '10px',
              fontSize: '14px',
              background: 'var(--border-2)'
            }}
            onClick={handleCopy}
            data-testid="btn-copy-ref-link"
          >
            {t('btn_copy')}
          </button>
        </div>
        <button
          className="btn btn--primary"
          onClick={handleShare}
          data-testid="btn-share-telegram"
        >
          <IconSend />
          {t('btn_share_telegram')}
        </button>
      </section>

      <section className="col">
        <span className="label">{t('how_works_title')}</span>
        <div className="list">
          <div className="list__row" style={{ justifyContent: 'flex-start', fontSize: '14px', color: 'var(--text-2)', gap: '12px' }}>
            <b style={{ color: 'var(--accent-text)' }}>1</b>
            {t('how_step1')}
          </div>
          <div className="list__row" style={{ justifyContent: 'flex-start', fontSize: '14px', color: 'var(--text-2)', gap: '12px' }}>
            <b style={{ color: 'var(--accent-text)' }}>2</b>
            {t('how_step2')}
          </div>
          <div className="list__row" style={{ justifyContent: 'flex-start', fontSize: '14px', color: 'var(--text-2)', gap: '12px' }}>
            <b style={{ color: 'var(--accent-text)' }}>3</b>
            {t('how_step3', { pct })}
          </div>
        </div>
      </section>

      <section className="col">
        <span className="label">{t('invited_list_title')}</span>
        {r && r.referrals && r.referrals.length > 0 ? (
          <div className="list" data-testid="ref-users-list">
            {r.referrals.map((x, idx) => (
              <div className="list__row" key={idx}>
                <span>{x.name}</span>
                <b>{money(x.earned)}</b>
              </div>
            ))}
          </div>
        ) : (
          <div className="empty" data-testid="ref-empty">
            <b>{t('ref_empty')}</b>
            <span className="small muted">{t('ref_empty_sub')}</span>
          </div>
        )}
      </section>
    </main>
  );
}
